import React, { useEffect, useState } from 'react';

import { IntlProvider, addLocaleData } from 'react-intl';
import ar from 'react-intl/locale-data/ar';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import fr from 'react-intl/locale-data/fr';
import ko from 'react-intl/locale-data/ko';
import ru from 'react-intl/locale-data/ru';
import th from 'react-intl/locale-data/th';
import zh from 'react-intl/locale-data/zh';
// import hant from 'react-intl/locale-data/'

const language = navigator.language || navigator.browserLanguage;

let currentLocale;
// eslint-disable-next-line import/no-mutable-exports
let intl;

const loadLocalePackage = async () => {
  if (language.startsWith('zh')) {
    if (language.endsWith('TW') || language.endsWith('HK') || language.endsWith('MO')) {
      currentLocale = (await import('@/i18n/zh-Hant')).default;
    } else {
      currentLocale = (await import('@/i18n/zh-CN')).default;
    }
  } else if (language.startsWith('ru')) {
    currentLocale = (await import('@/i18n/ru')).default;
  } else if (language.startsWith('fr')) {
    currentLocale = (await import('@/i18n/fr')).default;
  } else if (language.startsWith('es')) {
    currentLocale = (await import('@/i18n/es')).default;
  } else if (language.startsWith('ko')) {
    currentLocale = (await import('@/i18n/ko')).default;
  } else if (language.startsWith('th')) {
    currentLocale = (await import('@/i18n/th')).default;
  } else if (language.startsWith('ar')) {
    currentLocale = (await import('@/i18n/ar')).default;
  } else {
    currentLocale = (await import('@/i18n/en-US')).default;
  }

  const { intl: _intl } = new IntlProvider(
    {
      // 是中文显示中文，否则默认英文;
      // 如果不这么写的话，非中英文会显示语言编码翻译失败;
      locale: language.startsWith('zh')
        ? language
        : language.startsWith('ru')
        ? 'ru'
        : language.startsWith('fr')
        ? 'fr'
        : language.startsWith('es')
        ? 'es'
        : language.startsWith('ko')
        ? 'ko'
        : language.startsWith('th')
        ? 'th'
        : language.startsWith('ar')
        ? 'ar'
        : 'en',
      messages: currentLocale,
    },
    {}
  ).getChildContext();

  intl = _intl;
};

addLocaleData([...ar, ...en, ...zh, ...ru, ...fr, ...es, ...ko, ...th]);

export function formatMessage(id, defaultMessage = '', values = {}) {
  // console.log(values);
  return intl ? intl.formatMessage({ id, defaultMessage }, values) : '';
}

export function IntlContainer(props) {
  const [localeLoaded, setLocaleLoaded] = useState(false);

  useEffect(() => {
    loadLocalePackage().then(() => {
      setLocaleLoaded(true);
    });
  }, []);
  if (!localeLoaded) return null;
  return (
    <IntlProvider locale={language} messages={currentLocale}>
      {props.children}
    </IntlProvider>
  );
}

export default intl;
